module.exports = __webpack_public_path__ + "static/15-ba4c30bcdf4fa78f677206034d9abad0.jpg";